export default {
  namespaced: true,
  state: {
    transactions: [
      'MOMO',
      'OM',
      'EUM'
    ],
    operators: [
      'eq',
      'lte',
      'gte'
    ],
    status: [
      'NEW',
      'PENDING',
      'ERROR',
      'CANCEL',
      'TIMEOUT',
      'SUCCESS'
    ]
  },
  getters: {
    transactions: state => {
      return state.transactions
    },
    operators: state => {
      return state.operators
    },
    status: state => {
      return state.status
    }
  }
}